module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text/9-fc64beb564ed758f7fbb61d0cf4a04c0.jpg";